import React from 'react';
import { css } from 'emotion';
import { Spinner } from '../../../../shared/Spinner';

/**
 * TODO: Remove when encore/anchro colors is done https://anchorfm.atlassian.net/browse/WHEEL-825
 * @deprecated Use the `LoadingIndicator` in @spotify-internal/encore-web
 */
export function Loading({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) {
  return (
    <div
      data-testid="loading-spinner"
      className={css`
        display: grid;
        place-content: center;
        ${className}
      `}
    >
      <div
        className={css`
          width: 100%;
          max-width: 50px;
        `}
      >
        <Spinner type="circle" color={color} />
      </div>
    </div>
  );
}
